import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
// use utc time
dayjs.extend(utc);

export default dayjs;
